import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "./AuthContext";

const DeploymentModelContext = createContext();

export const DeploymentModelProvider = ({ children }) => {
  const [deploymentModels, setDeploymentModels] = useState([]);
  const { isAuthenticated, authVersion } = useAuth();

  // Fetch Deployment Model Options
  const fetchDeploymentModels = async () => {
    try {
      const response = await api.get("/DeploymentModel/deploymentmodels");
      setDeploymentModels(response.data || []);
    } catch (error) {}
  };

  // Fetch when user is authenticated (and re-fetch after login)
  useEffect(() => {
    if (isAuthenticated) {
      fetchDeploymentModels();
    }
  }, [isAuthenticated, authVersion]);

  return (
    <DeploymentModelContext.Provider value={{ deploymentModels }}>
      {children}
    </DeploymentModelContext.Provider>
  );
};

// ✅ Custom Hook
export const useDeploymentModels = () => {
  const { deploymentModels } = useContext(DeploymentModelContext);
  return deploymentModels;
};
